import React, { useEffect } from "react";
import { Typography, Stack, Divider, Button, Box } from "digiwash-components";
import { formatNumber } from "digiwash-core";
import PageContainer from "../components/PageContainer";
import Header from "../components/AppHeader";
import PageContainerShape from "../containers/PageContainerShape";
import { boxRatioWidth, getEnv } from "../helpers/general";
import useBack from "../hooks/useBack";
import { Helmet } from "react-helmet";
import CustomIcon from "../components/CustomIcon";
import BoxRatio from "../components/BoxRatio";
import { Linking } from "react-native";
import { useHomePageContent } from "../hooks/useHomePageContent";
import Loading from "../components/Loading";

const ANDROID_VERSION_CODE = getEnv("ANDROID_VERSION_CODE");
const ANDROID_VERSION_NAME = getEnv("ANDROID_VERSION_NAME");
const ANDROID_APP_ID = getEnv("ANDROID_APP_ID");

function AppInfo() {
  let back = useBack();
  let {
    retrieve: homePageContentRetrieve,
    data: homePageContentData,
    error: homePageContentError,
    loading: homePageContentLoading,
  } = useHomePageContent();
  useEffect(() => {
    homePageContentRetrieve();
  }, []);

  return (
    <>
      <Helmet>
        <title>اطلاعات اپلیکیشن | دیجی واش</title>
      </Helmet>
      <PageContainer
        insideBeignScrollView={
          <Header title="نسخه اپلیکیشن" onBack={back}>
            <PageContainerShape>
              <Stack
                distribution="center"
                direction="vertical"
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <>
                  {homePageContentLoading ? (
                    <Loading color="primary.main" />
                  ) : null}
                  {!homePageContentLoading && !!homePageContentError ? (
                    <Typography alignment="center" fs="xm" color="common.black">
                      خطا در اتصال به سرور.
                    </Typography>
                  ) : null}
                  {!homePageContentLoading && !!homePageContentData ? (
                    <>
                      <BoxRatio
                        fixedWidth={boxRatioWidth({
                          columns: 1,
                          padding: ["xxl", "xxl"],
                        })}
                        ratio="2:1"
                      >
                        <CustomIcon icon="appInfo" width="100%" height="100%" />
                      </BoxRatio>
                      <Divider size="xxl" />
                      <Typography fs="xm" ff="mainMedium" color="common.black">
                        نسخه ساخت: {formatNumber(ANDROID_VERSION_CODE)}
                      </Typography>
                      <Typography fs="xm" ff="mainMedium" color="common.black">
                        نسخه اپلیکیشن: {formatNumber(ANDROID_VERSION_NAME)}
                      </Typography>
                      <Divider size="xxxl" />
                      {!!homePageContentData.appInfo[0]?.max_version ? (
                        <>
                          {ANDROID_VERSION_CODE ===
                          homePageContentData.appInfo[0].max_version ? (
                            <Typography
                              alignment="center"
                              fs="xm"
                              color="common.black"
                            >
                              شما از آخرین نسخه اپلیکیشن استفاده میکنید.
                            </Typography>
                          ) : (
                            <>
                              <Box style={{ width: "100%" }}>
                                <Button
                                  onPress={() => {
                                    Linking.openURL(
                                      "bazaar://details?id=" + ANDROID_APP_ID
                                    );
                                  }}
                                  outline
                                >
                                  بروزرسانی اپلیکیشن از کافه بازار
                                </Button>
                              </Box>
                              <Divider size="l" />
                              <Box style={{ width: "100%" }}>
                                <Button
                                  onPress={() => {
                                    Linking.openURL(
                                      "http://play.google.com/store/apps/details?id=com.digiwash.laundry"
                                    );
                                  }}
                                  outline
                                >
                                  بروزرسانی اپلیکیشن از گوگل پلی
                                </Button>
                              </Box>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <Box style={{ width: "100%" }}>
                            <Button
                              onPress={() => {
                                Linking.openURL(
                                  "bazaar://details?id=" + ANDROID_APP_ID
                                );
                              }}
                              outline
                            >
                              بررسی آپدیت از کافه بازار
                            </Button>
                          </Box>
                          <Divider size="l" />
                          <Box style={{ width: "100%" }}>
                            <Button
                              onPress={() => {
                                Linking.openURL(
                                  "http://play.google.com/store/apps/details?id=com.digiwash.laundry"
                                );
                              }}
                              outline
                            >
                              بررسی آپدیت از گوگل پلی
                            </Button>
                          </Box>
                        </>
                      )}
                    </>
                  ) : null}
                </>
              </Stack>
            </PageContainerShape>
          </Header>
        }
      ></PageContainer>
    </>
  );
}

export default AppInfo;
